import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Spin, message } from "antd";

import NewsletterTemplateForm from "./NewsletterTemplateForm";
import useNewsletterTemplatesAdmin from "hooks/web-templates/useNewsletterTemplatesAdmin";


export default function EditorNewsletterTemplate() {
  const { templateId:id } = useParams();
  console.log("id", id);
  const navigate = useNavigate();
  const { getTemplateById, updateTemplate } = useNewsletterTemplatesAdmin();

  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) {
      message.error("No template specified");
    //   navigate("/ovizia/newsletter-templates");
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const fetched = await getTemplateById(id);
        if (!cancelled) setTemplate(fetched);
      } catch (err) {
        if (!cancelled) {
          message.error("Failed to load template");
          navigate("/ovizia/newsletter-templates");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSubmit = async (values) => {
    try {
      await updateTemplate(id, values);
      navigate(-1);
    } catch (err) {
      throw err;
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: 64 }}>
        <Spin />
      </div>
    );
  }

  return (
    <NewsletterTemplateForm
      initialValues={template}
      onSubmit={handleSubmit}
      submitLabel="Save Changes"
      isEditing
    />
  );
}